<template>
  <v-card class="px-12 py-10" outlined>
    <h2 class="text-center" v-html="$t('attempting.title', { login: login })"/>
    <lottie class="my-7" :options="lottieOptions" :height="150" :width="150"/>
    <p class="text-center" v-html="$t('attempting.description', { server: server })"/>
  </v-card>
</template>

<script>
import * as animationData from "@/assets/animations/syncing.json";
import AuthRepository from '../../../repositories/auth';

import Vue from 'vue';
import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti);

export default {
  name: "SyncAttempt",
  props: {
    login: String,
    server: String,
    investorPassword: String,
    accountType: String,
  },
  data() {
    return {
      confettiOptions: {
        defaultColors: [
          'PaleGreen',
          'Gold',
          'lightblue',
        ],
        defaultDropRate: 6,
        defaultSize: 5,
        windSpeedMax: 0,
        particlesPerFrame: 1,
      },
      lottieOptions: { animationData: animationData.default },
      syncStatus: 'attempting', // Status: attempting, successful, error
    }
  },
  mounted() {
    //this.$confetti.start(this.confettiOptions);
  },
  destroyed() {
    this.$confetti.stop();
  },
  methods: {
    async loadFirstTrades() {
      //TODO Request to load 30 days trades of synced account


      //TODO Review if below requests are needed
      await AuthRepository.getUser().then((response) => {this.setUser(response.data);});
      await AuthRepository.getLanguage().then((response) => { this.setPreferredLanguage(response.data); });
      await AuthRepository.getUserDetails().then((response) => { this.setUserDetails(response.data); });
      await AuthRepository.analyzeNewUserLogin();

      this.$confetti.stop();
      await this.$router.push('/dashboard');
      this.close();
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>

